import type { Exchanger } from "../exchanger";

export const PriceType = {
  FIXED: "FIXED",
  FLOATING: "FLOATING",
} as const;

export type PriceType = (typeof PriceType)[keyof typeof PriceType];

export interface Exchange {
  id: string;
  exchangerId: string;
  exchanger?: Exchanger;
  baseCurrency: string;
  quoteCurrency: string;
  buyPrice?: number | null;
  sellPrice?: number | null;
  minAmount: number;
  maxAmount: number;
  isActive: boolean;
  isClosed: boolean;
  priceMode: PriceType;
  spreadBps: number;
  volatilityFactor: string | number;
  lastRefreshedAt?: string | null;
  expiresAt?: string | null;
  version: number;
  createdAt: string;
  updatedAt?: string | null;
  deletedAt?: string | null;
}
